<template lang='pug'>
  .view-container
    .reminders-container
      .title.center Reminders
      .slide-container
        .arrow-left.arrow(@click='prevReminder')
          include ../assets/icons/arrow-left.svg
        transition(name="fade" mode="out-in")
          .slide(:key='reminderIndex')
            img(:src="require('@/assets/illustrations/'+this.reminder.illustration+'-'+this.$store.state.theme+'.svg')")
            .text {{reminder.text}}
        .arrow-right.arrow(@click='nextReminder')
          include ../assets/icons/arrow-right.svg
      .navigation-container
        .dot(
          v-for='(reminder, index) in reminders' 
          @click='reminderIndex = index'
          :class="{active:index===reminderIndex}")
      
    .buttons-container
      label.button.accent(for='select') Select photo
      input#select(
        type="file" 
        accept="image/*" 
        name="select" 
        ref='select' 
        @input='uploadPhoto' 
        @change='uploadPhoto')
</template>

<script>
export default {
  data(){
    return {
      reminderInterval: null,
      reminderIndex: 0,
      reminders: [
        {
          illustration: 'landscape',
          text: "Photos should be taken in landscape.",
        },
        {
          illustration: 'flash',
          text: "Flash should be enabled.",
        },
        {
          illustration: 'distance',
          text: "Camera is 33cm or 13 inches away from subject.",
        },
      ].sort(() => Math.sign(0.5 - Math.random())),
    }
  },
  mounted(){
    
  },
  beforeDestroy(){

  },
  computed: {
    reminder(){
      return this.reminders[this.reminderIndex]
    },
  },
  methods: {
    uploadPhoto(event){
      const file = event.target.files[0]
      const fileReader = new FileReader()
      fileReader.onerror = e => {
        alert(e.message)
      }
      fileReader.onload = () => {
        const image = new Image()
        image.onerror = e => {
          alert(e.message)
        }
        image.onload = () => {
          this.$store.commit('setPhoto', image)
          this.$router.push({
            name: 'eyes',
          })
        }
        image.src = fileReader.result
      }
      fileReader.readAsDataURL(file)
    },
    // startReminders(){
    //   this.stopReminders()
    //   this.reminderInterval = setInterval(this.nextReminder, 3500)
    // },
    // stopReminders(){},
    prevReminder(){
      this.reminderIndex = Math.max(0, this.reminderIndex - 1)
    },
    nextReminder(){
      this.reminderIndex = Math.min(this.reminders.length - 1, this.reminderIndex + 1)
    },
  },
}
</script>

<style scoped lang="sass">
@import ../sass/variables

input#select
  position: fixed
  top: -100%
  left: -100%

.view-container
  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: center

  .reminders-container
    flex-grow: 1
    flex-shrink: 1
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    width: 100%
    &, *
      user-select: none

    .title
    .slide-container
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
      .arrow
        &, *
          cursor: pointer
        padding: 1em
        flex-grow: 0
        flex-shrink: 0
      .slide
        flex-grow: 1
        flex-shrink: 1
        img
          display: block
          width: 100%
          margin: 1em auto
        .text
          text-align: center
    .navigation-container
      padding-bottom: 2em
      margin-top: 1em
      display: flex
      justify-content: center
      align-items: center
      .dot
        flex-grow: 0
        flex-shrink: 0
        margin: 0.2em
        $size: 0.8em
        height: $size
        width: $size
        background-color: var(--bg3)
        border-radius: 9999px
        transition: all 0.2s
        cursor: pointer
        &.active
          background-color: var(--ac1)
          width: $size * 2

  .buttons-container
    flex-grow: 0
    flex-shrink: 0

.arrow *
  fill: var(--ac1)

</style>
